import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { message, Button, Dropdown, Menu, Modal, Spin, Typography } from "antd";
import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";

import moment from "moment";

import { DESKTOP_DOWN } from "../../config/mediaQueries";

import { generalActions } from "./../../redux/actions";

import { holidaysService } from "./../../redux/services";

import {
	UIAvatarLabel,
	UIPageListing,
} from "./../../components";

import { kpisAfterToggle, statusKpis } from "./../../components/KpiCards";

import ModalRecalculate from './ModalRecalculate';

import ModalShow from "./show";
import ModalFilters from "./filters";
import ModalEdit from "./edit";
import ModalCreate from "./create";

const UPCOMING_DAYS = 30;

const weekday = (date) => {
	const name = date.format("dddd");

	return name.charAt(0).toUpperCase() + name.slice(1);
};

const getNextOccurrence = (item) => {
	const today = moment().startOf("day");
	const date = moment(item.data_feriado, "YYYY-MM-DD");

	if (item.recorrente) {
		date.year(today.year());

		if (date.isBefore(today)) {
			date.add(1, "year");
		}
	}

	return date.isBefore(today) ? null : date;
};

const getScope = (item) => {
	if (!item.todos_funcionarios) return "Funcionários selecionados";
	if (!item.todos_departamentos) return "Departamentos selecionados";
	if (!item.todas_empresas) return "Empresas selecionadas";

	return "Todos os funcionários";
};

const config = {
	title            : "Feriados",
	subtitle         : "Gerencie os feriados considerados no cálculo do ponto.",
	icon             : <i className="fal fa-calendar-alt" />,
	infoBanner       : {
		icon       : <i className="fal fa-info-circle" />,
		title      : "Sobre os feriados",
		description: "Os feriados cadastrados aqui são considerados no cálculo do ponto e podem gerar abono ou hora extra conforme as regras do horário.",
	},
	permissionPrefix : "feriados",
	list             : "feriados",
	searchPlaceholder: "Buscar por nome do feriado",
	orders           : [
		{
			label  : "Mais recentes",
			field  : "id",
			sort   : "desc",
			default: true,
		},
		{
			label: "Mais antigos",
			field: "id",
			sort : "asc",
		},
		{
			label: "Nome A|Z",
			field: "descricao",
			sort : "asc",
		},
		{
			label: "Nome Z|A",
			field: "descricao",
			sort : "desc",
		},
	],
};

class Index extends Component {
	constructor(props) {
		super(props);

		const defaultOrder = config.orders.find(o => o.default);

		this.state = {
			isLoading   : false,
			isSending   : false,
			recalcularModalVisible: false,
			listType    : "list",
			data        : [],
			pagination  : {
				current : 1,
				pageSize: 20,
				total   : 0,
			},
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
			search      : "",
			// Actions
			editModalVisible    : false,
			showModalVisible    : false,
			exportModalVisible  : false,
			filtersModalVisible : false,
			activeLoadings      : [],
			isExporting         : false,
			passwordModalVisible: false,
			// Images
			imagePreviewVisible: false,
			imagePreviewImage  : "",
			// Media queries
			desktopDown: false,
			// Filters
			filters     : {
				recorrente   : null,
				ativo        : 1,
				created_at   : null,
				proximos_dias: null,
			},
			deleted: false,
			summary: null,
			kpis: null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if( props.listType && state.listType !== props.listType )
		{
			return {
				listType: props.listType
			};
		}

		return null;
	}

	componentDidMount() {
		this.fetchGetAll(true);

		this.fetchSummary();

		enquire.register(DESKTOP_DOWN, {
			match  : () => { this.setState({ desktopDown: true }) },
			unmatch: () => { this.setState({ desktopDown: false }) }
		});

	};

	componentWillUnmount() {
		enquire.unregister(DESKTOP_DOWN);
	};

	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		const listTypeCard = this.state.listType === "card";
		return [
			{
				title  : "Data",
				width  : 200,
				visible: !listTypeCard,
				render : (item) => {
					const date = moment(item.data_feriado, "YYYY-MM-DD");

					return (
						<UIAvatarLabel
							name={date.format("DD/MM/YYYY")}
							subtitle={weekday(date)}
							icon={<i className="fal fa-calendar-alt" />}
							tone="primary"
							square
						/>
					);
				},
			},
			{
				title : "Feriado",
				render: (item) => {
					if (listTypeCard) {
						const date = moment(item.data_feriado, "YYYY-MM-DD");

						return (
							<UIAvatarLabel
								name={item.descricao}
								subtitle={`${date.format("DD/MM/YYYY")} · ${weekday(date)}`}
								icon={<i className="fal fa-calendar-alt" />}
								tone="primary"
								square
							/>
						);
					}

					return item.descricao;
				},
			},
			{
				title    : "Recorrência",
				className: "no-ellipsis card-block-width-2",
				width    : 130,
				render   : (item) => (
					<span className={`status-tag ${item.recorrente ? "status-tag-info" : "status-tag-neutral"}`}>
						{item.recorrente ? "Todo ano" : "Data única"}
					</span>
				),
			},
			{
				title    : "Abrangência",
				className: "card-block-width-2",
				width    : 210,
				render   : (item) => listTypeCard ? (
					<Fragment>
						<i className="fal fa-users" style={{ marginRight: 5 }} />{getScope(item)}
					</Fragment>
				) : getScope(item),
			},
			{
				title : "Próximo em",
				width : 150,
				render: (item) => {
					const next = getNextOccurrence(item);

					if (!next) return "-";

					const days = next.diff(moment().startOf("day"), "days");
					const label = days === 0 ? "Hoje" : days === 1 ? "Amanhã" : `Em ${days} dias`;

					return (
						<div className="cell-icon-info">
							<div className="cell-icon-info-text">
								<Typography.Text className="cell-icon-info-title">{label}</Typography.Text>
								<Typography.Text type="secondary" className="cell-icon-info-subtitle">{next.format("DD/MM/YYYY")}</Typography.Text>
							</div>
						</div>
					);
				},
			},
			{
				title    : "Status",
				className: "active no-ellipsis",
				width: 90,
				render   : (item) => this.state.activeLoadings.indexOf(item.uuid) !== -1 ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : (
					<span className={`status-tag ${item.ativo ? "status-tag-success" : "status-tag-error"}`}>
						<i className="status-tag-dot" />
						{item.ativo ? "Ativo" : "Inativo"}
					</span>
				)
			},
			{
				title    : "Ações",
				className: "actions no-ellipsis",
				visible  : this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete"),
				render   : (item) => (
					<Dropdown overlay={this.menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	fetchGetAll = (init = false, exportItems = false) => {
		const {pagination, orderByField, orderBySort, search, filters} = this.state;
		if( exportItems )
		{
			this.setState({
				isExporting: true,
			});
		}
		else
		{
			this.setState({
				isLoading: true,
			});
		}

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search : search,
		};

		if( exportItems )
		{
			data.exportItems = true;
		}
		else
		{
			data.page  = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if( filters.recorrente !== null ) {
			data.recorrente = filters.recorrente;
		}

		if( filters.ativo !== null )
		{
			data.ativo = filters.ativo;
		}

		if( filters.proximos_dias )
		{
			data.proximos_dias = filters.proximos_dias;
		}

		if( filters.created_at )
		{
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		holidaysService.getAll(data)
		.then((response) => {
			if( exportItems )
			{	
				this.setState({
					isExporting: false,
				});

				window.open(response.data.file_url, "_blank");
			}
			else
			{
				this.setState(state => ({
					isLoading : false,
					data      : response.data.data,
					kpis      : response.data.kpis ?? null,
					pagination: {
						...state.pagination,
						current: response.data.meta.current_page,
						total  : response.data.meta.total,
					},
				}));
			}
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	fetchSummary = () => {
		holidaysService.getAll({ ativo: 1, page: 1, limit: 366 })
			.then((response) => {
				const holidays = response.data.data ?? [];
				const today = moment().startOf("day");
				const upcomingLimit = today.clone().add(UPCOMING_DAYS, "days");
				const recurring = holidays.filter((item) => item.recorrente).length;

				this.setState({
					summary: {
						total: holidays.length,
						thisYear: holidays.filter((item) => item.recorrente || moment(item.data_feriado, "YYYY-MM-DD").year() === today.year()).length,
						upcoming: holidays.filter((item) => {
							const next = getNextOccurrence(item);

							return next && next.isSameOrBefore(upcomingLimit);
						}).length,
						recurring,
						single: holidays.length - recurring,
					},
				});
			})
			.catch(() => {
				this.setState({
					summary: null,
				});
			});
	};

	onStatusKpiChange = (status) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				ativo: status,
			},
		}), () => this.fetchGetAll(true));
	};

	// Próximos, recorrentes e datas únicas são exclusivos entre si; clicar no card já ativo limpa o filtro
	onTypeKpiChange = (type, isActive) => {
		const typeFilters = {
			upcoming: {recorrente: null, proximos_dias: UPCOMING_DAYS},
			recurring: {recorrente: 1, proximos_dias: null},
			single: {recorrente: 0, proximos_dias: null},
		};

		this.setState(state => ({
			filters: {
				...state.filters,
				...(isActive ? {recorrente: null, proximos_dias: null} : typeFilters[type]),
			},
		}), () => this.fetchGetAll(true));
	};

	kpis = () => {
		const { summary, filters } = this.state;
		const percent = (amount) => summary?.total ? `${Math.round(amount / summary.total * 100)}% dos ativos` : "0% dos ativos";
		const isUpcomingActive = !!filters.proximos_dias;
		const isRecurringActive = !isUpcomingActive && filters.recorrente === 1;
		const isSingleActive = !isUpcomingActive && filters.recorrente === 0;

		return [
			...statusKpis({
				kpis          : this.state.kpis,
				icon          : <i className="fal fa-calendar-alt" />,
				title         : "Total de feriados",
				caption       : "Feriados cadastrados",
				status        : this.state.filters.ativo,
				onStatusChange: this.onStatusKpiChange,
			}),
			{
				key    : "this-year",
				tone   : "amber",
				icon   : <i className="fal fa-calendar-star" />,
				title  : "Feriados no ano",
				value  : summary?.thisYear ?? null,
				caption: `Em ${moment().year()}`,
			},
			{
				key    : "upcoming",
				tone   : "neutral",
				icon   : <i className="fal fa-calendar-check" />,
				title  : "Próximos feriados",
				value  : summary?.upcoming ?? null,
				caption: `Nos próximos ${UPCOMING_DAYS} dias`,
				onClick: () => this.onTypeKpiChange("upcoming", isUpcomingActive),
				active : isUpcomingActive,
			},
			{
				key    : "recurring",
				tone   : "neutral",
				icon   : <i className="fal fa-sync-alt" />,
				title  : "Recorrentes",
				value  : summary?.recurring ?? null,
				caption: percent(summary?.recurring ?? 0),
				onClick: () => this.onTypeKpiChange("recurring", isRecurringActive),
				active : isRecurringActive,
			},
			{
				key    : "single",
				tone   : "neutral",
				icon   : <i className="fal fa-calendar-day" />,
				title  : "Datas únicas",
				value  : summary?.single ?? null,
				caption: percent(summary?.single ?? 0),
				onClick: () => this.onTypeKpiChange("single", isSingleActive),
				active : isSingleActive,
			},
		];
	};

	onListTypeChange = (type) => {
		this.props.onChangeListType(type);
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll();
		});
	};

	onOrderChange = (value) => {
		const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

		if( !defaultOrder ) return null;

		this.setState(state => ({
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
		}), () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if( !e.hasOwnProperty("type") )
		{
			const {search} = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if( search )
				{
					this.fetchGetAll(true);
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	showOpen = ({uuid}, general_key) => {
		this.setState({showModalVisible: true});

		// On open screen
		this.showScreen.onOpen(uuid, general_key);
	};

	showOnClose = () => {
		this.setState({showModalVisible: false});
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = (data) => {
		Modal.confirm({
			title          : "Confirmar exclusão!",
			content        : "Tem certeza de que deseja excluir este registro?",
			okText         : "Excluir",
			autoFocusButton: null,
			onOk           : () => {
				this.deleteConfirmed(data);
			}
		});
	};

	// TODO Verificar
	deleteConfirmed = (data) => {
		const { uuid } = data;
		return holidaysService.destroy({uuid})
			.then((response) => {
				console.log('teste', response);
				this.setState(({
					deleted: true,
				}))
				this.recalculateOpen(data);
			})
			.catch((data) => {
				Modal.error({
					title  : "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({createModalVisible: true});

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({createModalVisible: false});
	};

	createOnComplete = () => {
		this.setState({createModalVisible: false});
		// Fecth all
		this.fetchGetAll(true);

		this.fetchSummary();

		// setTimeout(() => {
		// 	this.showOpen(this.state.data[0]);
		// }, 1000);
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({uuid}) => {
		this.setState({editModalVisible: true});

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	editOnClose = () => {
		this.setState({editModalVisible: false});
	};

	editOnComplete = () => {
		this.setState({editModalVisible: false});

		// Fecth all
		this.fetchGetAll();

		this.fetchSummary();
	};

	/**
	 * Password
	 */
	passwordOpen = (item) => {
		this.setState({passwordModalVisible: true});

		// On open screen
		this.passwordScreen.onOpen(item);
	};

	passwordOnClose = () => {
		this.setState({passwordModalVisible: false});
	};

	passwordOnComplete = () => {
		this.setState({passwordModalVisible: false});

		Modal.success({
			title  : "E-mail enviado!",
			content: "Foi enviado para o usuário sua nova senha.",
		});
	};

	/**
	 * Filter
	 */
	filtersOpen = () => {
		this.setState({filtersModalVisible: true});

		// On open screen
		this.filtersScreen.onOpen({...this.state.filters});
	};

	filtersOnClose = () => {
		this.setState({filtersModalVisible: false});
	};

	filtersOnComplete = (filters) => {
		this.setState({filtersModalVisible: false});
		this.setState({
			filters: filters,
		}, () => {
			// Fecth all
			this.fetchGetAll(true);
		});
	};

	/**
	 * Active/Desactive
	 *
	 * @param {number} uuid
	 * @param {boolean} activate
	 */
	activateDeactivate = ({uuid}, activate) => {
		const {activeLoadings} = this.state;

		if( activeLoadings.indexOf(uuid) === -1 )
		{
			activeLoadings.push(uuid);
		}

		this.setState({
			activeLoadings: activeLoadings,
		});

		holidaysService.edit({uuid, ativo: activate})
		.then((response) => {
			const newData = [...this.state.data];
			const index   = newData.findIndex(item => uuid === item.uuid);

			if( index !== -1 )
			{
				const item = newData[index];

				newData.splice(index, 1, {
					...item,
					status: response.data.data.status,
				});

				this.setState(state => ({
					data: newData,
					kpis: response.data.data.ativo === undefined ? state.kpis : kpisAfterToggle(state.kpis, item.ativo == 1, response.data.data.ativo == 1),
				}));
			}
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		}).finally(() => {
			const {activeLoadings} = this.state;
			const index            = activeLoadings.indexOf(uuid);

			if( index !== -1 )
			{
				activeLoadings.splice(index, 1);

				this.setState({
					activeLoadings: activeLoadings,
				});
			}
		});
	};

	/**
	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({imagePreviewVisible: false});

	onImagePreview = (url) => {
		this.setState({
			imagePreviewImage  : url,
			imagePreviewVisible: true,
		});
	};

	recalculateOpen = ({ uuid }) => {
		this.setState({
			recalcularModalVisible: true,
			isLoading: false,
			isSending: false,
		});

		console.log('recal', uuid);

		// On open screen
		this.recalculateScreen.onOpen(uuid);
	};

	recalculateOnClose = (uuid) => {
		this.setState({ recalcularModalVisible: false });

		// Success message
		message.success("Registro atualizado com sucesso.");

		// Callback
		this.fetchGetAll();

		this.fetchSummary();
	};

	recalculateOnComplete = () => {
		this.setState({ recalcularModalVisible: false }, () => {
			this.setState({
				isSending: false,
			});

			// Success message
			message.success("Cálculo realizado com sucesso.");

			// Callback
			this.fetchGetAll();

			this.fetchSummary();
		});
	};

	onCancelRecalculate = () => {
		this.setState({ recalcularModalVisible: false });
		// Callback
		this.fetchGetAll();

		this.fetchSummary();
	}

	render() {
		const { recalcularModalVisible, deleted } = this.state;

		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						kpis={this.kpis()}
						infoBanner={config.infoBanner}
						onSearch={this.onSearch}
						onSearchChange={this.onSearchChange}
						onPaginationChange={this.onPaginationChange}
						onOrderChange={this.onOrderChange}
						onListTypeChange={this.onListTypeChange}
						onFiltersClick={this.filtersOpen}
						isLoading={this.state.isLoading}
						listType={this.state.listType}
						orderByField={this.state.orderByField}
						orderBySort={this.state.orderBySort}
						orders={config.orders}
						search={this.state.search}
						searchPlaceholder={config.searchPlaceholder}
						data={this.state.data}
						pagination={this.state.pagination}
						columns={this.columns()}
						showFilters={true}
						buttons={[
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
								onClick: this.createOpen,
								title  : "Incluir",
								icon   : <i className="far fa-plus" />,
							},
							{
								visible: false , // TODO this.props.permissions.includes(config.permissionPrefix + ".export"),
								onClick: () => this.fetchGetAll(true, true),
								title  : this.state.isExporting ? "Exportando" : "Exportar",
								icon   : <i className="fal fa-file-export" />,
								loading: this.state.isExporting,
							},
						]}
					/>
				</div>
				<ModalCreate
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
				<Modal wrapClassName="modal-image" visible={this.state.imagePreviewVisible} centered footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>

				<ModalRecalculate
					ref={el => this.recalculateScreen = el}
					visible={recalcularModalVisible}
					onComplete={this.recalculateOnComplete}
					onClose={this.recalculateOnClose}
					onCancel={this.onCancelRecalculate}
					deleted={deleted}
				/>
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType   : state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
